import React from 'react';
import { i18n } from 'config/locales';
import ValidationElement from 'components/Form/ValidationElement';
import { ValidationElementProps } from 'components/Form/ValidationElement/ValidationElement';
import { CommonOnUpdate, CommonOnError, CommonRequired } from 'types/props';
import { LegalInvestigationsIssueOutcomeModel } from 'forms/sections/legal/investigation/issues/types';
import Textarea from 'components/Form/Textarea';
import { setAttribute } from 'components/Form/shared/setAttribute';
import Dropdown from 'components/Form/Dropdown';

interface Props
  extends Partial<LegalInvestigationsIssueOutcomeModel>,
  ValidationElementProps {
  onUpdate?: CommonOnUpdate
  onError?: CommonOnError
  required?: CommonRequired
  disabled?: boolean
  attribute?: string
  className?: string
}

export default class IssueOutcome extends ValidationElement<Props> {
  constructor(props) {
    super(props);

    this.state = {
      uid: `${this.props.Outcome}-${super.guid()}`,
    };
  }

  update = (queue: Partial<LegalInvestigationsIssueOutcomeModel>) => {
    this.props.onUpdate({
      Outcome: this.props.Outcome,
      OutcomeExplanation: this.props.OutcomeExplanation,
      ...queue,
    });
  };

  updateOutcome = (value: LegalInvestigationsIssueOutcomeModel['Outcome']) => {
    this.update({
      Outcome: value,
    });
  };

  updateOutcomeExplanation = (value: LegalInvestigationsIssueOutcomeModel['OutcomeExplanation']) => {
    this.update({
      OutcomeExplanation: value,
    });
  };

  getOutcomeOptions = () => {
    const prefix = 'legal.pvq.investigations.outcome';
    return [
      { label: '', value: '' },
      { label: i18n.t(`${prefix}.suspended`), value: 'Still suspended' },
      { label: i18n.t(`${prefix}.reinstated`), value: 'Reinstated' },
      { label: i18n.t(`${prefix}.revoked`), value: 'Revoked' },
      { label: i18n.t(`${prefix}.other`), value: 'Other' },
    ];
  };

  render() {
    return (
      <div className={this.props.className}>
        <Dropdown
          {...this.props.Outcome}
          placeholder={this.props.Outcome?.value}
          attribute={setAttribute(this.props.attribute, 'outcome')}
          name="outcome"
          onUpdate={this.updateOutcome}
          onError={this.props.onError}
          sort={false}
          value={this.props.Outcome?.value}
          required={this.props.required}
          suggestionsRenderProvided
        >
          {this.getOutcomeOptions().map((option) => (
            <option key={`name-${option.label}`} label={option.label} value={option.value}>
              {option.label}
            </option>
          ))}
        </Dropdown>
        {this.props.Outcome?.value === 'Other' &&
          <>
            {i18n.t('legal.pvq.investigations.outcome.explain')}
            <Textarea
              {...this.props.OutcomeExplanation}
              name="OutcomeExplanation"
              className="legal-investigations-piv-outcome-explanation"
              onUpdate={this.updateOutcomeExplanation}
              onError={this.props.onError}
              required={this.props.required}
              disabled={this.props.disabled}
              attribute={`${this.props.attribute}.OutcomeExplanation`}
            />
          </>
        }
      </div>
    )
  }
}

IssueOutcome.defaultProps = {
  className: 'issue-outcome',
  Outcome: {},
  OutcomeExplanation: {},
  onUpdate: (queue) => { },
  onError: (value, arr: ErrorCode[]) => arr,
};

IssueOutcome.errors = [];
